import EncryptUtility from "../../utility/js/encrypt-utility";
import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import AddFavourite from "../../utility/js/addFav";
import Utility from "../../../shared/utility";
import salesService from ".././js/sales-order-service.js";
import commonApiService from "../../common/js/common-api-service.js";
import moment from "moment";
export default {
  data: () => ({
    max50Rule: [(v) => (v || "").length <= 50 || "Max Length of 50 character", (v) => !!v || "Field is required"],
    max10Rule: [
      (v) => (v || "").length <= 10 || "Max Length of 10 character",
      (v) => (v || "").length >= 2 || "Min Length of 2 character",
      (v) => !!v || "Field is required",
    ],
    nDayRule: [
      (v) => !!v || "Field is required",
      (v) => Number.isInteger(Number(v)) || "Must be a valid integer",
    ],
    backSlash: true,
    refresh: true,
    userId: EncryptUtility.localStorageDecrypt("userID"),
    actionList: [],
    mainPage: "",
    favouriteList: [],
    pageUrl: "",
    subPage: "",
    showAdd: false,
    subPageUrl: "",
    backSlashParent: true,
    search: "",
    totalRecords: 0,
    allowedEdit: false,
    addSoTypeDialog: false,
    editSoTypeDialog: false,
    deletesSoDialog: false,
    otype_id: 0,
    status: 0,
    isedit: false,
    isAdd: false,
    timelineEnabled: false,
    nDay: "",
    cutoffTime: "",
    cutoffTimeMenu: false,
    nDayUpdate: "",
    cutoffTimeUpdate: "",
    cutoffTimeUpdateMenu: false,
    ordCodeNew: "",
    ordDescriptionNew: "",
    ordCodeUpdate: "",
    ordDescriptionUpdate: "",
    json_fields: {
      ord_code: "Order Code",
      ord_descrip: "Order Description",
      active: "Status",
    },
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    headers: [
      {
        text: "Order Code",
        align: "start",
        value: "ord_code",
        class: "primary customwhite--text",
        width: "10%",
      },
      {
        text: "Order Description",
        value: "ord_descrip",
        class: "primary customwhite--text",
        width: "20%",
      },

      {
        text: "Status",
        value: "active",
        class: "primary customwhite--text",
        width: "7%",
      },
      {
        text: "Actions",
        value: "actions",
        class: "primary customwhite--text",
        sortable: false,
        width: "5%",
      },
    ],
    soTypeList: [],
    projectList: [],
    isAction: true,
    editOrdCode: true,
    selectedProject: "",
  }),
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
  },
  mounted() {
    this.getProject();
  },
  computed: {
    computedCutoffTimeFormatted() {
      return this.cutoffTime ? moment(this.cutoffTime, "HH:mm").format("hh:mm A") : "";
    },
    computedCutoffTimeUpdateFormatted() {
      return this.cutoffTimeUpdate ? moment(this.cutoffTimeUpdate, "HH:mm").format("hh:mm A") : "";
    },
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.selectedProject = "";
      this.soTypeList = [];
      this.$refs.SoTypeForm.resetValidation();
      this.getProject();
      this.totalRecords = 0;
      this.isAdd = false;
      this.isAction = true;
      this.editOrdCode = true;
      this.search = "";
    },
    //New Sales Order Button Click Event
    newAddClicked() {
      this.addSoTypeDialog = true;
    },
    //API call to get project list
    async getProject() {
      let projectData = await commonApiService.getProject("get",this.userId);
      this.projectList = projectData.ProjectInfo;
    },
    //Once project is selected
    projectSelected() {
      if (this.selectedProject !== "" && this.selectedProject !== undefined && this.selectedProject !== null) {
        this.isAdd = true;
        this.getSoList();
      } else if (this.selectedProject == null) {
        this.soTypeList = [];
        this.totalRecords = 0;
      }
    },
    //To get sales order list based on the project
    async getSoList() {
      this.soTypeList = [];
      this.totalRecords = 0;
      let obj = {
        UserId: parseInt(this.userId),
        pass: 1,
        proj_key: parseInt(this.selectedProject),
      };
      let response = await salesService.postSoSearchData(obj);
      if (response.message !== "NA" && response !== 400) {
        this.soTypeList = response;
        this.totalRecords = this.soTypeList.length;
      }
    },
    //Add Sales Order button Click Event
    addSoTypes() {
      //to check form
      if (this.$refs.addSoForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        //Data for post
        let groupdata = {
          UserId: parseInt(this.userId),
          pass: 2,
          ord_code: this.ordCodeNew,
          ord_descrip: this.ordDescriptionNew,
          proj_key: parseInt(this.selectedProject),
          ...this.getTimelinePayload(this.timelineEnabled, this.nDay, this.cutoffTime),
        };
        //API call
        this.axios
          .post("/so/so_manage_so_types", groupdata)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.addSoTypeDialog = false;
              this.$refs.addSoForm.reset();
              this.getSoList();
              this.$store.commit("ConfigModule/Alert", Alert);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.addSoTypeDialog = false;
              this.$refs.addSoForm.reset();
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
            this.$refs.addSoForm.reset();
          });
      } else {
        this.addSoTypeDialog = true;
      }
    },
    //To update Sales Order Type
    updateSoType(isEditOrdCodeAllow) {
      if (this.$refs.EditSoform.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        if (this.active == true) {
          this.status = 1;
        } else {
          this.status = 0;
        }
        let groupdata = {
          pass: isEditOrdCodeAllow ? 5 : 3,
          status: parseInt(this.status),
          otype_id: parseInt(this.otype_id),
          UserId: parseInt(this.userId),
          ord_code: this.ordCodeUpdate,
          ord_descrip: this.ordDescriptionUpdate,
          proj_key: parseInt(this.selectedProject),
          ...this.getTimelinePayload(this.timelineEnabled, this.nDayUpdate, this.cutoffTimeUpdate),
        };
        this.axios
          .post("/so/so_manage_so_types", groupdata)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.getSoList();
              this.editSoTypeDialog = false;
              this.deletesSoDialog = false;
              this.$refs.EditSoform.reset();
              (this.editUrl = ""), (this.allowedEdit = false);
              this.$store.commit("ConfigModule/Alert", Alert);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.editSoTypeDialog = false;
              this.deletesSoDialog = false;
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      } else {
        this.editSoTypeDialog = true;
      }
    },
    //Delete Sales Order
    deleteSoType() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      let groupdata = {
        pass: 4,
        status: 0,
        otype_id: parseInt(this.otype_id),
        UserId: parseInt(this.userId),
        ord_code: this.ordCodeUpdate,
        ord_descrip: this.ordDescriptionUpdate,
        proj_key: parseInt(this.selectedProject),
      };
      this.axios
        .post("/so/so_manage_so_types", groupdata)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.getSoList();
            this.deletesSoDialog = false;
            this.editSoTypeDialog = false;
            this.$store.commit("ConfigModule/Alert", Alert);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.deletesSoDialog = false;
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //To edit existing Sales Order
    editItem(item) {
      this.editSoTypeDialog = true;
      this.otype_id = item.otype_id;
      this.ordCodeUpdate = item.ord_code;
      this.timelineEnabled = this.toBooleanValue(this.getTimelineValue(item, "timeline_enabled"));
      this.nDayUpdate = item.timeline_nday;
      this.ordDescriptionUpdate = item.ord_descrip;
      this.cutoffTimeUpdate = this.normalizeCutoffTimeForPicker(this.getTimelineValue(item, "timeline_cutoff_time"));
      this.active = item.active;
      this.isedit = false;
      this.editOrdCode = true;
      this.isAction = item.isaction == 0 ? false : true;
    },
    getTimelinePayload(enabled, nDay, cutoffTime) {
      const timelineEnabled = this.toBooleanValue(enabled);
      return {
        timeline_enabled: timelineEnabled ? 1 : 0,
        timeline_nday: timelineEnabled ? parseInt(nDay) : 0,
        timeline_cutoff_time: timelineEnabled ? this.normalizeCutoffTimeForPost(cutoffTime) : null,
      };
    },
    getTimelineValue(item, key) {
      const keyParts = key.split("_");
      const camelKey = keyParts[0] + keyParts.slice(1).map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join("");
      const pascalKey = camelKey.charAt(0).toUpperCase() + camelKey.slice(1);
      return item[key] ?? item[camelKey] ?? item[pascalKey];
    },
    toBooleanValue(value) {
      return value === true || value === 1 || value === "1" || String(value).toLowerCase() === "true";
    },
    normalizeCutoffTimeForPicker(value) {
      if (!value) return "";
      const stringValue = String(value).trim();
      const timeMatch = stringValue.match(/(\d{1,2}):(\d{2})(?::\d{2})?/);
      if (timeMatch) {
        return `${timeMatch[1].padStart(2, "0")}:${timeMatch[2]}`;
      }
      const parsedTime = moment(stringValue);
      return parsedTime.isValid() ? parsedTime.format("HH:mm") : "";
    },
    normalizeCutoffTimeForPost(value) {
      if (!value) return null;
      const parsedTime = moment(value, ["HH:mm:ss", "HH:mm"], true);
      return parsedTime.isValid() ? parsedTime.format("HH:mm:ss") : value;
    },
    //Add or remove Favourtite
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    //To allow edit based on the data
    allowEdit() {
      this.allowedEdit = true;
      this.isedit = true;
      this.editOrdCode = !this.isAction;
    },
    //To allow delete based on the data
    allowDelete() {
      this.deletesSoDialog = true;
    },
    //Close button click event in the popups
    closeDialog() {
      if (this.editSoTypeDialog) {
        this.$refs.EditSoform.resetValidation();
        this.editSoTypeDialog = false;
        this.ordCodeUpdate = "";
        this.ordDescriptionUpdate = "";
        this.nDayUpdate = "";
        this.cutoffTimeUpdate = "";
        this.timelineEnabled = false;
      } else if (this.addSoTypeDialog) {
        this.$refs.addSoForm.resetValidation();
        this.addSoTypeDialog = false;
        this.ordCodeNew = "";
        this.nDay = "";
        this.ordDescriptionNew = "";
        this.cutoffTime = "";
        this.timelineEnabled = false;
      }
      this.allowedEdit = false;
      this.deletesSoDialog = false;
      this.isedit = false;
    },
    //To cancel in dialog box
    onClickCancel() {
      if (this.addSoTypeDialog) {
        this.$refs.addSoForm.resetValidation();
        this.addSoTypeDialog = false;
        this.ordCodeNew = "";
        this.ordDescriptionNew = "";
        this.nDay = "";
        this.cutoffTime = "";
        this.timelineEnabled = false;
      } else {
        this.$refs.EditSoform.resetValidation();
        this.editSoTypeDialog = false;
        this.ordCodeUpdate = "";
        this.nDayUpdate = "";
        this.ordDescriptionUpdate = "";
        this.cutoffTimeUpdate = "";
        this.timelineEnabled = false;
      }
      this.allowedEdit = false;
      this.deletesSoDialog = false;
      this.isedit = false;
    },
    //ord code in update input event
    ordCodeUpdateChange() {
      if (this.ordCodeUpdate !== null) {
        this.ordCodeUpdate = this.ordCodeUpdate.toUpperCase();
      }
    },
    //nDay in update input event
    nDayUpdateChange() {},
    //ord code in new input event
    ordCodeNewChange() {
      if (this.ordCodeNew !== null) {
        this.ordCodeNew = this.ordCodeNew.toUpperCase();
      }
    },
    //nDay in new input event
    nDayChange() {},
    //ord description in new input event
    ordDescriptionNewChange() {
      if (this.ordDescriptionNew !== null) {
        this.ordDescriptionNew = this.ordDescriptionNew.toUpperCase();
      }
    },
    //ord description in update input event
    ordDescriptionUpdateChange() {
      if (this.ordDescriptionUpdate !== null) {
        this.ordDescriptionUpdate = this.ordDescriptionUpdate.toUpperCase();
      }
    },
  },
  components: {
    breadcrumbComp,
  },
};
